<template>
  <div id="app">
    <Navbar/>
    <Home/>
    <Update/>
    <Members/>
    <Results/>
    <Schedule/>
    <ContactUs/>
    <Footer/>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Home from './components/Home.vue'
import Members from './components/Members.vue'
import Update from './components/Update.vue'
import Results from './components/Results.vue'
import Schedule from './components/Schedule.vue'
import ContactUs from './components/ContactUs.vue'
import Footer from './components/Footer.vue'
import * as THREE from 'three'
import WAVES from 'vanta/dist/vanta.waves.min'

export default {
  name: 'app',
  components: {
    Navbar, Home, Members, Results, Schedule, ContactUs, Footer, Update
  },
  mounted() {
        this.vantaEffect = WAVES({
            el: "#app",
            THREE: THREE 
        })
    }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/all";

// Set your colors
$primary: #4099FF;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: #4099FF;
$transparent: rgba(0,0,0,0);

$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert),
    "transparent": ($transparent, white)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

#app {
  position: inherit !important;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}
a.anchor {
    display: block;
    position: relative;
    top: -52px;
    visibility: hidden;
}
.title {
    font-size: 48px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    padding-bottom: 20px;
    padding-top: 30px;
    color: #005080;
}
.ul {
  list-style-type: circle;
  text-align: left;
  padding-left: 20px;
}
::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 15px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar
{
	width: 5px;
  height: 5px;
	background-color: #F5F5F5;
}

::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #008CBA;
}
</style>
